import { AppClientConfigurationService } from '@sdbn/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonPropertiesService {

  constructor(
    private appClientConfigurationService: AppClientConfigurationService
  ) { }


  /* terminal properties */
  // TODO: Property muss verschoben werden in common
  public getLanguageSelectionCardSize () :string {
    const propertyValue = this.appClientConfigurationService.getPropertyValue('tmc-yard.terminal.language-selection-card-size');

    if (propertyValue.length != 0) {
      return propertyValue;
    }
    return null;
  }


}
